import { z } from 'zod'
/**
 * Validates if the provided string is a valid email address format.
 *
 * The validation uses a regular expression to check if the email address has a valid structure,
 * including allowed characters before the '@' symbol, a valid domain name, and a top-level domain.
 *
 * @param {string} emailAddress - The email address to be validated.
 * @returns {boolean} `true` if the email address matches a valid format; `false` otherwise.
 */
export const isEmailAddress = (emailAddress: string): boolean => {
  return z.email().safeParse(emailAddress).success
}
